import { forwardRef, HStack, useRadioGroup } from '@chakra-ui/react';
import RadioCardInput from './RadioCardInput';
import { RadioInputGroupProps } from './RadioInputGroup';

const RadioCardInputGroup = forwardRef<RadioInputGroupProps, 'input'>(
    (
        { name, options, value, onChange, color, inputProps = {}, ...rest },
        ref
    ) => {
        const { getRootProps, getRadioProps } = useRadioGroup({
            name,
            defaultValue: value,
            onChange,
        });

        const group = getRootProps();

        return (
            <HStack {...rest} {...group}>
                {options.map(({ value, label }, i) => {
                    const radio = getRadioProps({ value });
                    const props = { color, ...radio, ...inputProps };
                    if (i === 0) props['ref'] = ref;
                    return (
                        <RadioCardInput key={value} {...props}>
                            {label}
                        </RadioCardInput>
                    );
                })}
            </HStack>
        );
    }
);

export default RadioCardInputGroup;
